import React, {Component} from 'react';

import {
    Line,
    ResponsiveContainer,
    Tooltip,
    LineChart
} from 'recharts';




const CustomizedTooltip = ({ active, payload, label }) => {
	if (active) {
	    return (
	    	<div className="custom-tooltip" style={{backgroundColor : "white", border : "1px solid gray", borderRound : "5px", padding : "3px 5px"}}>
	    		{payload[0].payload.name} : {payload[0].value}
	    	</div>
	    );
	  }

  return null;
}


class ArrowInfo extends Component {
	render(){
		
		if(this.props.rate == 0) {
			return (
					<div className="metric-label d-inline-block float-right font-weight-bold text-info">
						<span className="text-muted mr-2">전월대비</span>
						<span className="icon-circle-small icon-box-xs bg-info-light"><i className="fa fa-fw fa-arrow-right"></i></span>
						<span className="ml-1">{this.props.rate}%</span>
					</div>
			)
		} else if(this.props.rate > 0) {
			return (
					<div className="metric-label d-inline-block float-right font-weight-bold text-danger">
						<span className="text-muted mr-2">전월대비</span>
						<span className="icon-circle-small icon-box-xs bg-danger-light"><i className="fa fa-fw fa-arrow-up"></i></span>
						<span className="ml-1">{this.props.rate}%</span>
					</div>
			)
		} else {
			return (
					<div className="metric-label d-inline-block float-right font-weight-bold text-success">
						<span className="text-muted mr-2">전월대비</span>
						<span className="icon-circle-small icon-box-xs bg-success-light"><i className="fa fa-fw fa-arrow-down"></i></span>
						<span className="ml-1">{this.props.rate}%</span>
					</div>
			)
		}
		
	}
}

class SparklineCard extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		if(this.props.data) {
			return (
				<div className="card border-top border-top-primary" style={{paddingBottom:"5px"}}>
					<div className="card-body pt-2" style={{marginBottom:"-30px"}}>
						<h5 className="text-muted mb-1">{this.props.title}</h5>
						<div className="metric-value d-inline-block">
							<h3 className="mb-1">{this.props.value}</h3>
						</div>
						<ArrowInfo rate={this.props.rate}/>
					</div>
					<ResponsiveContainer height={40}>
						<LineChart data={this.props.data}
		                           margin={{top: 5, right: 5, left: 5, bottom: 5}}>
		                    <Line type='monotone' dataKey='value' stroke={this.props.strokeColor ? this.props.strokeColor : "#3ac47d"}
		                          strokeWidth={2} strokeOpacity={0.5} />
                          			
		                    <Tooltip content={<CustomizedTooltip />}/>
		                </LineChart>
					</ResponsiveContainer>
				</div>
			)
		} else {
			return (
				<div className="card border-top border-top-primary" style={{paddingBottom:"5px"}}>
					<div className="card-body">
						<h5 className="text-muted">{this.props.title}</h5>
						<div className="metric-value d-inline-block">
							<h3 className="mb-1">{this.props.value}</h3>
						</div>
						<ArrowInfo rate={this.props.rate}/>
					</div>
				</div>
			)
		}
		
	}

}


export default SparklineCard;